import Selectors from './utils/selectors.js';

const selectors = new Selectors();

export default class AutoTabFields {
    constructor(options = {}) {
        this.id = options.id;
        this.thresholdAttr = options.thresholdAttr || 'maxlength';
        this.inputContainer = document.querySelector(this.id);
        this.setupTabListener();
    }

    setupTabListener() {
        const inputFields = selectors.querySelectorArray('input', this.inputContainer);
        inputFields.forEach((el, index) => {
            const maxlength = el.getAttribute(this.thresholdAttr);
            if (maxlength && index != inputFields.length - 1) {
                el.addEventListener('keyup', (e) => {
                    if (e.key.length == 1 && el.value.length == maxlength && el.validity.valid && !inputFields[index + 1].value) {
                        inputFields[index + 1].focus();
                    }
                });
            }
        });
    }
}
